import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Layers, Cpu, Timer } from "lucide-react";
import { api, mediaUrl } from "@/lib/api";

export const Portfolio = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/portfolio").then(({ data }) => setItems(data)).catch(() => {});
  }, []);

  return (
    <div data-testid="portfolio-grid">
      <SectionHead
        eyebrow="Prova de trabalho"
        title="Peças fabricadas em Portugal"
        subtitle="Casos reais de prototipagem e produção. Cada peça produzida com controlo dimensional e material adequado à aplicação."
      />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
        {items.map((it, i) => (
          <motion.div
            key={it.id}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
            data-testid={`portfolio-item-${i}`}
            className="group bg-ax-card border border-ax-border rounded-xl overflow-hidden hover:border-ax-cyan/60 transition-all hover:-translate-y-1"
          >
            <div className="relative h-52 overflow-hidden">
              <img src={mediaUrl(it.image_url)} alt={it.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              <span className="absolute top-3 left-3 font-mono text-[11px] uppercase tracking-wider px-2.5 py-1 rounded bg-ax-bg/85 text-ax-cyan border border-ax-border">
                {it.technology}
              </span>
            </div>
            <div className="p-5">
              <h4 className="font-heading font-semibold text-ax-text leading-snug">{it.title}</h4>
              <p className="text-sm text-ax-sub mt-1.5 leading-relaxed">{it.application}</p>
              <div className="mt-4 pt-4 border-t border-ax-border grid grid-cols-2 gap-3 text-xs">
                <Spec icon={Layers} label={it.material} />
                <Spec icon={Cpu} label={it.tolerance || "—"} />
                <Spec icon={Timer} label={it.production_time || "—"} />
              </div>
            </div>
          </motion.div>
        ))}
      </div>
      {items.length === 0 && (
        <p className="text-center text-ax-muted mt-12">Portfólio a ser preenchido em breve.</p>
      )}
    </div>
  );
};

const Spec = ({ icon: Icon, label }) => (
  <div className="flex items-center gap-1.5 text-ax-sub">
    <Icon className="w-3.5 h-3.5 text-ax-orange shrink-0" /> <span className="truncate">{label}</span>
  </div>
);

export const SectionHead = ({ eyebrow, title, subtitle }) => (
  <div className="max-w-2xl">
    <span className="font-mono text-xs uppercase tracking-widest text-ax-cyan">{eyebrow}</span>
    <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-ax-text mt-3">{title}</h2>
    {subtitle && <p className="text-ax-sub mt-4 leading-relaxed">{subtitle}</p>}
  </div>
);
